export const getConsent = () => window.OneTrust;

export const toggleConsentPopup = () =>
    new Promise(resolve => {
        let consent = getConsent();
        consent.ToggleInfoDisplay();
        resolve();
    });
